<template>
  <div class="tw-relative tw-z-50">
    <NavigationTopBar class="tw-hidden md:tw-block" />
    <header
      data-allow-mismatch
      class="fast-header tw-fixed tw-inset-x-0 tw-w-full tw-rounded-none tw-bg-white"
      :class="headerClasses"
    >
      <QToolbar class="fast-ecommerce-toolbar tw-container tw-flex tw-h-[68px] tw-items-center tw-justify-between md:tw-h-20">
        <!-- Logo -->
        <NavigationLogo />

        <!-- Navigation -->
        <nav class="tw-hidden xl:tw-flex tw-h-full tw-items-center">
          <NavigationMenu
            class="tw-h-full"
            menu-text-class="tw-text-[16px] tw-leading-6 tw-font-normal"
          />
        </nav>

        <QBtn
          flat
          round
          dense
          icon="menu"
          color="dark"
          class="fast-ecommerce-menu-button tw-block xl:tw-hidden"
          @click="emit('click-mobile-menu')"
        />
      </QToolbar>
    </header>
  </div>
</template>

<script setup lang="ts">
defineProps({
  isHomepage: {
    type: Boolean,
    default: false,
  },
});

const { scrollY } = useHydrationSafeScroll();
const isTopBarAreaVisible = computed(() => scrollY.value < 40);

const headerClasses = computed(() => ({
  'tw-top-0': !isTopBarAreaVisible.value,
  'md:tw-top-10': isTopBarAreaVisible.value,
  'tw-shadow-[0px_2px_4px_rgba(24,24,24,0.12)]': true,
}));

const emit = defineEmits(['click-mobile-menu']);
</script>

<style>
.fast-ecommerce-menu-button.q-btn {
  background: transparent !important;
}

.fast-ecommerce-menu-button.q-btn::before,
.fast-ecommerce-menu-button .q-focus-helper {
  display: none !important;
}

@media (max-width: 767px) {
  .fast-ecommerce-toolbar.q-toolbar {
    padding: 18px 16px !important;
  }

  .fast-ecommerce-toolbar .tw-container {
    max-width: 100% !important;
  }
}
</style>
